import { Box, Grid, Tooltip } from "@mui/material";
import type { JSX } from "react";
import type { FieldCaptionIcon } from "../fields/field-captions/FieldsCaptionIconSetContainer.tsx";
import FieldsCaptionIconSetContainer from "../fields/field-captions/FieldsCaptionIconSetContainer.tsx";
import SubCaption from "../fields/field-captions/SubCaption.tsx";

interface Props {
  Caption: JSX.Element;
  subCaption: string;
  subCaptionPrefix?: string;
  subCaptionColor?: string;
  subCaptionTooltip?: string;
  subCaptionValuesTooltip?: JSX.Element;
  isMandatory?: boolean;
  fieldCaptionIcons?: FieldCaptionIcon[];
}

export default function FieldCaptionWrapper({
  Caption,
  subCaption,
  subCaptionPrefix,
  subCaptionColor,
  subCaptionTooltip,
  subCaptionValuesTooltip,
  children,
  isMandatory,
  fieldCaptionIcons,
}: React.PropsWithChildren<Props>) {
  return (
    <Grid
      container
      sx={{
        flex: 1,
        minWidth: 0,
        width: "100%",
        display: "grid",
        flexWrap: "nowrap",
        gap: 0.5,
        px: 0.8,
        gridTemplateColumns: "minmax(0%, auto) minmax(0%, auto)",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", minWidth: "0px", overflow: "hidden", gap: 0.4 }}>
        {Caption}
        {fieldCaptionIcons && <FieldsCaptionIconSetContainer fieldCaptionIcons={fieldCaptionIcons} />}
        {children}
      </Box>
      <Box
        className="field-subcaption"
        sx={{ display: "flex", alignItems: "center", minWidth: "0px", overflow: "hidden", justifyContent: "end" }}
      >
        {isMandatory && subCaption.length === 0 && <SubCaption caption="Set Value..." color="text.secondary" />}
        {subCaption.length > 0 && subCaptionPrefix !== undefined && subCaptionPrefix.length > 0 && (
          <Box sx={{ flexShrink: 0, mr: 0.5 }}>
            <SubCaption caption={subCaptionPrefix} color="text.secondary" />
          </Box>
        )}
        {subCaption.length > 0 &&
          (subCaptionTooltip ? (
            <Tooltip title={subCaptionTooltip} arrow disableInteractive>
              <Box component="span" sx={{ minWidth: 0, overflow: "hidden" }}>
                <SubCaption caption={subCaption} color={subCaptionColor} />
              </Box>
            </Tooltip>
          ) : (
            <SubCaption caption={subCaption} color={subCaptionColor} overflowTooltip={subCaptionValuesTooltip} />
          ))}
      </Box>
    </Grid>
  );
}
